import { useAppSelector } from '../global/hooks';
import { selectSections } from '../store/sectionsSlice';

export default function useHasNoSections() {
	return useAppSelector(selectSections).length === 0;
}
